/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./DropZone.css";
import axios from "axios";
import { apiUrl } from "../../../constants";

const DropZone = ({
  setFile,
  title,
  idItemToBeUpdated,
  setErrorMessageDropZone,
  errorMessageDropZone,
}) => {
  const [previewUrl, setPreviewUrl] = useState("");
  const [publisherIcon, setPublisherIcon] = useState();
  const [loading, toggleLoading] = useState(false);

  // Here we receive the file on change and save it to send it to the server and to display it on the screen.
  function handleImageChange(e) {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    setPreviewUrl(URL.createObjectURL(uploadedFile));
  }

  // Here we handle the drop action.
  const dropHandler = (ev) => {
    const dropZone = document.getElementById("drop-zone-border");
    dropZone.style.border = "1px dashed #ececec";
    dropZone.style.backgroundColor = "white";
    const uploadedFile = ev.dataTransfer.files[0];
    setPublisherIcon();
    setFile(uploadedFile);
    setPreviewUrl(URL.createObjectURL(uploadedFile));
    ev.preventDefault();
  };

  // When we drag over the drop zone we change the styling.
  const dragOverHandler = (ev) => {
    const dropZone = document.getElementById("drop-zone-border");
    dropZone.style.border = "1px dashed #2185d0";
    dropZone.style.backgroundColor = "#D2EDFF";
    ev.preventDefault();
  };

  // Here we change the styling when we leave the dropzone.
  const dragLeaveHandler = (ev) => {
    const dropZone = document.getElementById("drop-zone-border");
    dropZone.style.border = "1px dashed #ececec";
    dropZone.style.backgroundColor = "white";
  };

  // If we are on the publisher page and would like to update we have an id and we will get the publisher icon to be displayed.
  useEffect(() => {
    if (title === "publisher" && idItemToBeUpdated) {
      getPublisherIcon();
    }
  }, [title, idItemToBeUpdated]);

  // Here we get the publisher icon if we are on the update page
  async function getPublisherIcon() {
    const jwtToken = localStorage.getItem("token");
    toggleLoading(true);
    try {
      const { data } = await axios.get(
        `${apiUrl}/api/formsettings/publishersicon/${idItemToBeUpdated}`,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      let fileType = "";
      if (data.charAt(0) === "/") {
        fileType = "jpeg";
      }
      if (data.charAt(0) === "i") {
        fileType = "png";
      }

      const image = `data:image/${fileType};base64,${data}`;
      setPublisherIcon(image);
    } catch (e) {
      console.error(e);

      if (e.response !== undefined) {
        setErrorMessageDropZone(e.response.data.message);
      } else {
        setErrorMessageDropZone(
          "Something went wrong. Please try again later."
        );
      }
    }
    toggleLoading(false);
  }

  return (
    <div className="upload-section">
      <section className="drop-zone-container">
        <div id="drop-zone-border">
          <section className="drop-zone-wrapper">
            <input
              type="file"
              name="image-field"
              onChange={handleImageChange}
              accept=".jpeg, .png, .jpg"
              id="drop-zone"
              onDrop={(e) => dropHandler(e)}
              onDragOver={(e) => dragOverHandler(e)}
              onDragLeave={(e) => dragLeaveHandler(e)}
            />
            <label htmlFor="drop-zone" className="label">
              Please drop your image here or click to select file
            </label>
          </section>
        </div>

        <label className="example-publisher-icon">
          {previewUrl && (
            <img
              src={previewUrl}
              alt="Preview"
              className="image-preview"
            />
          )}
          {publisherIcon && <img src={publisherIcon} alt="Publisher icon" />}
        </label>
      </section>
      <section className="errors-section">
        {errorMessageDropZone && <p>{errorMessageDropZone}</p>}
      </section>

      <div className="loading-wrapper">
        {loading && <p className="loading">Loading...</p>}
      </div>
    </div>
  );
};

export default DropZone;
